

<a (click)="openLoginModal($event)" href="#" [className]='className'
        [textContent]="nameLoginBtn"></a>
